/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Swal from 'sweetalert2';
import Loader from '../Common/Loader';
import List from '@material-ui/core/List';
import { withTranslation } from 'react-i18next';

import Account from './Account';
import UserService from '../../Service/UserService';
import BankService from '../../Service/BankService';
import { hot } from 'react-hot-loader';

const styles = theme => ({
	root: {
		minWidth: 190
	},
	grid: {
		display: 'flex'
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: 'center',
		color: theme.palette.text.secondary
	},
	title: {
		fontSize: 14
	},
	IconColor: {
		color: 'white'
	}
});

class BankDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false
		};
	}

	deleteAccount = async id => {
		this.setState({ _isLoading: true });
		const response = await BankService.delete(id);
		await this.handleResponse(response);
	};

	handleResponse = async response => {
		if (response.status) {
			const currentUser = await UserService.updateCurrentUser();
			this.props.setCurrentUser(currentUser);
		} else {
			this.toastError(response.data);
		}
		this.setState({
			_isLoading: false
		});
	};

	getAccounts = accounts => {
		const account = this.props.currentUser.profile.account || {};
		if (accounts.length > 0 && account.funding_source_id) {
			accounts.sort((a, b) =>
				a.institution_name > b.institution_name ? 1 : b.institution_name > a.institution_name ? -1 : 0
			); // NOSONAR
			return accounts.map(data => {
				return (
					<Account
						account_mask={data.account_mask}
						active={data.active}
						institution_name={data.institution_name}
						key={data.funding_source_id}
						OnDelete={() => this.deleteAccount(data.funding_source_id)}
						type={data.type}
					/>
				);
			});
		} else if (accounts.length === 0) {
			this.props.closeBankScreen();
		}
		return '';
	};

	toastError = error => {
		Swal.fire({
			allowOutsideClick: false,
			title: 'Error!',
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			text: error,
			// icon: 'error',
			confirmButtonText: 'Try Again...',
			customClass: 'otp_message_success',
			imageAlt: 'Custom Image'
		});
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<Grid alignItems="center" className={classes.root} container justify="center" spacing={2}>
				<Grid alignItems="center" className={classes.root} item justify="center" sm={8} spacing={2} xs={10}>
					<Paper className={classes.paper}>
						<Card className={classes.root} variant="outlined">
							<Button
								onClick={this.props.closeBankScreen}
								size="small"
								style={{ display: 'inline-block', float: 'left', fontSize: '12px' }}>
								<ArrowBackIosIcon />
								{t('buttons.back')}
							</Button>
							<Grid alignItems="center" item justify="center" sm={12} xs={12}>
								<Paper className={classes.paper}>
									<List className="accountlist">{this.getAccounts(this.props.accounts)}</List>

									<p style={{ fontWeight: 'initial', textAlign: 'left', color: 'black' }}>
										{t('profile.text_under_bank_account')}
									</p>
								</Paper>
							</Grid>
						</Card>
						{this.state._isLoading ? <Loader /> : ''}
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

export default hot(module)(withStyles(styles)(withTranslation()(BankDetail)));
